import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import ErrorBoundary from "./components/ErrorBoundary";
import WhatsAppButton from "./components/WhatsAppButton";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import RoutesPage from "./pages/RoutesPage";
import PrivateFlightsPage from "./pages/PrivateFlightsPage";
import AboutPage from "./pages/AboutPage";
import InformationPage from "./pages/InformationPage";
import ContactPage from "./pages/ContactPage";
import DestinoPage from "./pages/DestinoPage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminDashboard from "./pages/admin/AdminDashboard";

function App() {
  return (
    <ErrorBoundary name="App">
      <LanguageProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <ErrorBoundary name="Router">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/rutas" element={
                  <ErrorBoundary name="RoutesPage">
                    <RoutesPage />
                  </ErrorBoundary>
                } />
                <Route path="/destinos/:slug" element={
                  <ErrorBoundary name="DestinoPage">
                    <DestinoPage />
                  </ErrorBoundary>
                } />
                <Route path="/vuelos-privados" element={
                  <ErrorBoundary name="PrivateFlightsPage">
                    <PrivateFlightsPage />
                  </ErrorBoundary>
                } />
                <Route path="/sobre-nosotros" element={<AboutPage />} />
                <Route path="/informacion" element={<InformationPage />} />
                <Route path="/contacto" element={<ContactPage />} />
                
                {/* Admin Routes */}
                <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
              </Routes>
              <WhatsAppButton />
            </ErrorBoundary>
          </BrowserRouter>
        </div>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
